export { default as ComparativoMPVentasClass } from './Report'
